import api from "../Api";
import routes from "../constants/ApiRoutesConstants";

export default async function GetRecentSupplierUpdates() {
  const res = await api.get(routes.GET_RECENT_SUPPLIER_UPDATES);

  return res;
}
